import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type OxfordSuggestionsQueryVariables = Types.Exact<{
  inputs: Types.RespellingSuggestionsInputs;
}>;

export type OxfordSuggestionsQuery = {
  __typename?: 'Query';
  respellingSuggestions: Array<{
    __typename?: 'respellingSuggestion';
    word: string;
    respelling: string;
  }>;
  respellingSuggestionsByRegion: {
    __typename?: 'respellingSuggestionsByRegion';
    us: Array<{ __typename?: 'respellingSuggestion'; word: string; respelling: string }>;
    uk: Array<{ __typename?: 'respellingSuggestion'; word: string; respelling: string }>;
  };
};

export const OxfordSuggestionsDocument = gql`
  query OxfordSuggestions($inputs: respellingSuggestionsInputs!) {
    respellingSuggestions(inputs: $inputs) {
      word
      respelling
    }
    respellingSuggestionsByRegion(inputs: $inputs) {
      us {
        word
        respelling
      }
      uk {
        word
        respelling
      }
    }
  }
`;

/**
 * __useOxfordSuggestionsQuery__
 *
 * To run a query within a React component, call `useOxfordSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOxfordSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOxfordSuggestionsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useOxfordSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OxfordSuggestionsQuery,
    OxfordSuggestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OxfordSuggestionsQuery, OxfordSuggestionsQueryVariables>(
    OxfordSuggestionsDocument,
    options
  );
}
export function useOxfordSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OxfordSuggestionsQuery,
    OxfordSuggestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OxfordSuggestionsQuery, OxfordSuggestionsQueryVariables>(
    OxfordSuggestionsDocument,
    options
  );
}
export type OxfordSuggestionsQueryHookResult = ReturnType<
  typeof useOxfordSuggestionsQuery
>;
export type OxfordSuggestionsLazyQueryHookResult = ReturnType<
  typeof useOxfordSuggestionsLazyQuery
>;
export type OxfordSuggestionsQueryResult = Apollo.QueryResult<
  OxfordSuggestionsQuery,
  OxfordSuggestionsQueryVariables
>;
